import { useMutation } from '@tanstack/react-query';
import { queryClient } from '@/main.tsx';
import tripRepository from '@/api/repositories/tripRepository/TripRepository.ts';

const useTripDelete = (refetch = true) => {
  const mutationFn = async (request: Parameters<typeof tripRepository.delete>) => {
    return deleteAction(...request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      if (refetch) {
        void queryClient.invalidateQueries({ queryKey: ['trips'] });
        void queryClient.invalidateQueries({ queryKey: ['itineraries'] });
      }
    },
  });
};

export default useTripDelete;

async function deleteAction(...request: Parameters<typeof tripRepository.delete>): Promise<void> {
  const { error } = await tripRepository.delete(...request);

  if (error) throw new Error(error.message);
}
